import { SlateJsProxy } from './SlateJsProxy';

function getProxy(editorOrState) {
  if (SlateJsProxy.isEditorOrState(editorOrState)) {
    return SlateJsProxy;
  }
  throw new Error(
    'EditorStateProxy must be called with the editor or state as the first argument'
  );
}

export const EditorStateProxy = {
  createStateFromText: (e, text, service, data) =>
    getProxy(e).createStateFromText(e, text, service, data),
  getPlainText: (e) => getProxy(e).getPlainText(e),
  copyDraftEditorState: (draftFrom, draftTo) =>
    getProxy(draftFrom.editorState).copyDraftEditorState(draftFrom, draftTo),
  hasText: (e) => getProxy(e).hasText(e),
  hasUnshortenedLinks: (e) => getProxy(e).hasUnshortenedLinks(e),
  parseLinks: (e) => getProxy(e).parseLinks(e),
  removeFacebookAutocompleteEntities: (e) =>
    getProxy(e).removeFacebookAutocompleteEntities(e),
  getAllLinkedinAnnotations: (e) => getProxy(e).getAllLinkedinAnnotations(e),
  getFacebookAutocompleteEntities: (e) =>
    getProxy(e).getFacebookAutocompleteEntities(e),
  insertLinkedInAnnotation: (e, entityDetails) =>
    getProxy(e, entityDetails).insertLinkedInAnnotation(e, entityDetails),
  applyLinkedinAnnotation: (e, annotation) =>
    getProxy(e, annotation).applyLinkedinAnnotation(e, annotation),
  resetEditorState: (e) => getProxy(e).resetEditorState(e),
  findAndCreateTwitterHashtags: (e) =>
    getProxy(e).findAndCreateTwitterHashtags(e),
  findAndCreateFacebookMentions: (e, entities) =>
    getProxy(e).findAndCreateFacebookMentions(e, entities),
  replaceLinkWithShortLink: (e, link, shortLink) =>
    getProxy(e).replaceLinkWithShortLink(e, link, shortLink),
  replaceLinkWithUnshortenedLink: (e, unshortenedLink, shortLink) =>
    getProxy(e).replaceLinkWithUnshortenedLink(e, unshortenedLink, shortLink),
  findAndCreateTwitterMentions: (e) =>
    getProxy(e).findAndCreateTwitterMentions(e),
  insertHashtag: (e, text) => getProxy(e).insertHashtag(e, text),
};
